import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { TableComponent } from './table.component';

import { VirtualScrollerModule } from 'ngx-virtual-scroller';
import { DragScrollExtendedModule } from './components/drag-scroll';
import { HeaderRowModule } from './components/header-row/header-row.module';
import { RegularRowModule } from './components/regular-row/regular-row.module';
import { LoadingModule } from '@schoolbelle/common/loading';
import { NavBarModule } from '../shared';
import { TableService } from './table.service';
import { PhoneNumberPipe } from '@schoolbelle/common/phone-number';

@NgModule({
  declarations: [TableComponent],
  imports: [
    CommonModule,
    // NavBarModule,
    VirtualScrollerModule,
    DragScrollExtendedModule,
    HeaderRowModule,
    RegularRowModule,
    LoadingModule.forRoot(),
  ],
  providers:[DatePipe, PhoneNumberPipe, TableService],
  exports: [
    CommonModule,
    // NavBarModule,
    VirtualScrollerModule,
    DragScrollExtendedModule,
    HeaderRowModule,
    RegularRowModule,
    LoadingModule,
  ]
})
export class TableModule {}
